import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export default function CekPesanan() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (code.trim()) navigate(`/pesanan/${code.trim().toUpperCase()}`);
  };
  return (
    <section className="mx-auto min-h-[80vh] max-w-3xl px-5 pb-24 pt-36 sm:px-8 md:pt-44" data-testid="order-check-page">
      <p className="overline-label">Cek Pesanan</p>
      <h1 className="mt-4 font-display text-4xl font-light sm:text-5xl lg:text-6xl">Lacak status pesananmu.</h1>
      <p className="mt-4 text-neutral-400">Masukkan kode pesanan yang kamu terima setelah memesan (contoh: SG-AB12CD).</p>
      <form onSubmit={submit} className="mt-10 flex flex-col gap-3 sm:flex-row">
        <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="SG-XXXXXX" className="field h-14 flex-1 font-mono text-base uppercase tracking-widest" data-testid="order-check-input-code" />
        <button type="submit" className="btn-gold h-14 px-8" data-testid="order-check-btn-submit">
          <Search className="h-4 w-4" /> Cek
        </button>
      </form>
    </section>
  );
}
